import React, { useState, useRef } from 'react'
import { callAPI } from 'helpers'
import { get } from 'lodash'

// Components
import CustomModal from 'components/CustomModal'
import QuestionForm from './QuestionForm'
import { message } from 'antd'

export default ({ examId, questionNo, question, onSave, onCancel }) => {
  const questionFormRef = useRef()
  const [saving, setSaving] = useState()
  const questionId = get(question, 'examQuestionId')

  const _onQuestionSave = async () => {
    const formData = questionFormRef.current.getFormData()
    if (!formData) return
    try {
      setSaving(true)
      const imageURLs = await questionFormRef.current.uploadAllFiles()
      const { result: savedQuestion } = await callAPI({
        method: 'PUT',
        url: `/exams/${examId}/questions/${questionId}`,
        body: {
          ...formData,
          ...imageURLs
        }
      })
      setSaving(false)
      message.success(`บันทึกคำถามที่ ${questionNo} สำเร็จ`)
      onSave(savedQuestion)
    } catch (error) {
      console.error('Error while trying to save a question.', error)
      message.error(`บันทึกคำถามที่ ${questionNo} ไม่สำเร็จ, กรุณาลองใหม่อีกครั้ง`)
      setSaving(false)
    }
  }

  return (
    <CustomModal
      visible={Boolean(questionId)}
      cancelText='ย้อนกลับ'
      okText='บันทึกข้อมูล'
      okButtonProps={{
        loading: saving,
        icon: 'save'
      }}
      onCancel={onCancel}
      onOk={_onQuestionSave}>
      <QuestionForm
        ref={questionFormRef}
        question={question}
        questionNo={questionNo} />
    </CustomModal>
  )
}



// WEBPACK FOOTER //
// ./src/components/exams/QuestionEditModal.js